import { render, staticRenderFns } from "./VatInfoBox.vue?vue&type=template&id=0069149a&scoped=true"
import script from "./VatInfoBox.vue?vue&type=script&lang=ts"
export * from "./VatInfoBox.vue?vue&type=script&lang=ts"
import style0 from "./VatInfoBox.vue?vue&type=style&index=0&id=0069149a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0069149a",
  null
  
)

export default component.exports